import { DisplayKey } from './types';

/**
 * Helper to extract key data as displayKeys can be in string or object (`DisplayKeyObj`) format.
 * Second optional argument specifys the data to get when displayKey is of type `DisplayKeyObj`
 */
export const extractKeyData = (key: DisplayKey, displayKey: 'key' | 'columnName' = 'key') => {
  return typeof key === 'string' ? key : key[displayKey];
};
